import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { CoreService } from '../../../core/header/core.service';
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import { CoreComponent } from '../../../core/header/core.component';
import { AccountingAccountsService } from './accounting-accounts.service';
import { AccountingAccountsComponent } from './accounting-accounts.component';
import { AccountingAccountsModel } from './accounting-accounts.model';
import { AccountingAccountsDialogDeleteComponent } from './accounting-accounts-dialog-delete.component';
import { BehaviorSubject, Observable, merge, of } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { AccountingAccountsDialogLedgerComponent } from './accounting-accounts-dialog-ledger.component';
import { UntypedFormControl } from '@angular/forms';
import { Utils } from '../../../shared/utils';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-accountingAccounts-list',
    templateUrl: './accounting-accounts-list.component.html',
    styleUrls: ['./accounting-accounts-list.component.css'],
    standalone: false
})

export class AccountingAccountsListComponent implements OnInit, AfterViewInit {

  // Table With Pagination
  public displayedColumns: string[] = ['name', 'number', 'type', 'actions'];
  public data: AccountingAccountsModel[] = [];

  public pageSizeDefault: number = 30;
  public resultsLength: number = 0;
  public isLoadingResults: boolean = true;

  public actionRowClickedUid: string = "";
  public actionRowClickedModel: AccountingAccountsModel = new AccountingAccountsModel();

  public textSearchFormControl = new UntypedFormControl('');
  private filterAccountsClicked: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  @ViewChild(MatPaginator,{static: false}) paginator: MatPaginator;
  @ViewChild(MatSort,{static: false}) sort: MatSort;

  constructor(
    private router: Router,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
    private coreService: CoreService,
    public dialog: MatDialog,
    private dummy: DummyComponent,
    private core: CoreComponent
  ) { }

  ngOnInit() {
    this.coreService.setName('Plan contable');
  }

  ngAfterViewInit(): void {
    this.listAccountingAccounts();
  }

  public listAccountingAccounts(): void {
    merge(this.paginator.page, this.filterAccountsClicked)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.accountingAccountsService.list(
            this.paginator.pageIndex,
            this.pageSizeDefault,
            this.textSearchFormControl.value
          ).pipe(
            catchError(() => of(null))
          );
        }),
        map((data: any) => {
          this.isLoadingResults = false;

          if (data === null) {
            return [];
          }

          this.resultsLength = data.pages;
          return data.data;
        }),
      )
      .subscribe(data => (this.data = data));
  }

  public create(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const uid = null;
    this.dialog.open(AccountingAccountsComponent, {
      width: '80%',
      data: { uid: uid }
    });
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(AccountingAccountsComponent, {
      width: '80%',
      data: { uid: uid }
    });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(AccountingAccountsDialogDeleteComponent, {
      width: '420px',
      maxWidth: '95vw',
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.core.refresh();
        this.dummy.redirectTo(this.router.url);
      });
  }

  public ledger(id: number, name: string, number: string): void {
    this.dialog.open(AccountingAccountsDialogLedgerComponent, {
      width: '700px',
      maxWidth: '96vw',
      
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        id: id,
        name: name,
        number: number
      }
    });
  }

  public mayor(): void {
    this.dialog.open(AccountingAccountsDialogLedgerComponent, {
      width: '700px',
      maxWidth: '96vw',
      
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        id: this.actionRowClickedModel.id,
        name: this.actionRowClickedModel.name,
        number: this.actionRowClickedModel.number
      }
    });
  }

  public actionRowClicked(row: AccountingAccountsModel): void {
    this.actionRowClickedUid = row.uid;
    this.actionRowClickedModel = row;
  }

  public filterAccounts(): void {
    this.filterAccountsClicked.next(true);
  }

  public keyDownTabPress(event: any): void {

    const eventNumber: string = event.target.value;

    if (eventNumber.includes('.') === true) {

      const splitedNumber: string[] = eventNumber.split('.');

      // Result from 600.1 must be...
      // [0] -> 600 - [1] -> 1

      const firstPartLength: number = splitedNumber[0].length; // 3

      const secondPartLength: number = splitedNumber[1].length; // 1

      const maxLength: number = 10; // 10

      const totalLength: number = firstPartLength + secondPartLength; // 4

      const operationResult: number = maxLength - totalLength; // 6

      let zerosToComplete: string = '';

      for (let i = 0; i < operationResult; i++) {
        zerosToComplete += '0';
      }

      const numberCreation: string[] = [];

      numberCreation[0] = splitedNumber[0];

      numberCreation[1] = zerosToComplete;

      numberCreation[2] = splitedNumber[1];

      const result: string = numberCreation.join('');

      if (result.length === 10) {
        this.textSearchFormControl.setValue(result);
      }

    }

  }

  public keyDownTabAndEnterPress(event: any): void {

    const eventNumber: string = event.target.value;

    if (eventNumber.includes('.') === true) {

      const splitedNumber: string[] = eventNumber.split('.');

      // Result from 600.1 must be...
      // [0] -> 600 - [1] -> 1

      const firstPartLength: number = splitedNumber[0].length; // 3

      const secondPartLength: number = splitedNumber[1].length; // 1

      const maxLength: number = 10; // 10

      const totalLength: number = firstPartLength + secondPartLength; // 4

      const operationResult: number = maxLength - totalLength; // 6

      let zerosToComplete: string = '';

      for (let i = 0; i < operationResult; i++) {
        zerosToComplete += '0';
      }

      const numberCreation: string[] = [];

      numberCreation[0] = splitedNumber[0];

      numberCreation[1] = zerosToComplete;

      numberCreation[2] = splitedNumber[1];

      const result: string = numberCreation.join('');

      if (result.length === 10) {
        this.textSearchFormControl.setValue(result);
      }

      this.filterAccounts();

    }

  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public extracto(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.accountingAccountsService.excelExtractoContable(this.actionRowClickedModel.id)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Extracto contable"));

      }).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');

      });
  }

}
